/**
 * Client-side input validation. Hand-rolled (the portal has no zod dependency)
 * and intentionally mirrors the server's `packages/api/src/lib/validation.ts`
 * — same convention as E164_REGEX, which lives in both the API and `phone.ts`.
 * Keep the regexes in sync with the server; the server schema is always the
 * final gate, so client checks exist only to show a friendly message.
 */

// A real personal name: letters (any language, incl. accents), spaces,
// hyphens, apostrophes (straight + curly), periods; must contain a letter.
const NAME_PATTERN = /^(?=.*\p{L})[\p{L}\p{M} '’.-]+$/u;

// Looser nickname rule: digits allowed, no symbols / control chars.
const DISPLAY_NAME_PATTERN = /^[\p{L}\p{M}\p{N} '’.-]+$/u;

/** True if `s` is empty (let presence checks handle that) or a valid name. */
export const isValidName = (s: string): boolean => NAME_PATTERN.test(s.trim());

/** True if `s` is a valid nickname / display name. */
export const isValidNickname = (s: string): boolean => DISPLAY_NAME_PATTERN.test(s.trim());

/**
 * Loose email shape check — matches the existing client checks elsewhere. The
 * server's `z.string().email()` is the strict, final validator.
 */
export const isValidEmail = (s: string): boolean => /\S+@\S+\.\S+/.test(s.trim());

export const NAME_HELP = "Names can only contain letters, spaces, hyphens, and apostrophes.";
export const NICKNAME_HELP =
  "Nicknames can only contain letters, numbers, spaces, hyphens, and apostrophes.";
